import request from "../../utils/api";

export const login = body => request("login", { method: "post", body });
export const logout = id => request("api/auth/logout/" + id, {});
export const forgot = body => request("api/v1/users/forgotPassword", { method: "post", body });



// WEBPACK FOOTER //
// ./src/modules/auth/service.js